import { Components, Theme } from "@mui/material"

export const MuiAvatar: Components<Theme>["MuiAvatar"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: (theme.shape.borderRadius as number) * 3,
    }),
  },
}
